export default "<div *ngIf=\"loader.isLoading | async\" class=\"loader\">\n  <mat-spinner></mat-spinner>\n</div>\n"